import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { initTelegramViewport } from '@astral/telegram/webapp';
import '@astral/ui/styles.css';
import './styles/global.css';
import { App } from './App.js';

// Tell Telegram we're ready and expand to full height (no-op outside Telegram).
initTelegramViewport();

const container = document.getElementById('root');
if (!container) throw new Error('Root element #root not found');

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
